import each from './each';
import isArrayLike from './is-array-like';
var filter = function (arr, func) {
    if (!isArrayLike(arr)) {
        return arr;
    }
    var result = [];
    each(arr, function (value, index) {
        if (func(value, index)) {
            result.push(value);
        }
    });
    return result;
};
export default filter;
//# sourceMappingURL=filter.js.map